export const ColorMode = {
  RGB: '2',
};

export const Marker = {
  NUMBER: '#'.charCodeAt(0),
  CR: '$'.charCodeAt(0),
  LF: '-'.charCodeAt(0),
  REPEAT: '!'.charCodeAt(0),
};

export const ReaderState = {
  INITIAL: 0b0000,
  CONFIG_PARSED: 0b0001,
  READING_NUMBER: 0b0010,
  READING_SIXEL: 0b0100,
  REPEAT: 0b1000,
};

export const BLACK_CHAR_CODE = '?'.charCodeAt(0);
